import axios from "axios";
const apiClient = axios.create({
  baseURL: "https://apis.bakumia.pk/api",
});
export default apiClient;
export const IMAGE_BASE_URL = "https://apis.bakumia.pk";
export const PRODUCT_CATALOG_ID = "742074304188037";
